<template>
  <b-card class="dashboard-welcome-card" no-body>
    <b-card-header v-if="card.title" class="bg-white">
      <strong>{{card.title}}</strong>
    </b-card-header>

    <b-card-body>
      <rich-text-content :value="card.body"/>
    </b-card-body>

    <b-card-footer class="bg-white text-left" v-if="card.cta && typeof card.cta.url === 'string'">
      <b-button v-if="`${card.cta.url}`.startsWith('/')" :to="card.cta.url" variant="primary">{{ card.cta.text || defaultCtaText }}</b-button>
      <b-button v-else :href="card.cta.url" target="_blank" variant="primary">{{ card.cta.text || defaultCtaText }}</b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import { RichTextContent } from '@/components/RichTextField';

export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  components: {
    RichTextContent,
  },
  computed: {
    defaultCtaText() {
      const { cta } = this.card || {};
      if (cta && typeof cta.url === 'string') {
        if (cta.url.startsWith('mailto:')) {
          return cta.url.substr('mailto:'.length).split('?').shift();
        } else {
          return cta.url.replace(/http(s)?:\/\//, '');
        }
      } else {
        return null;
      }
    }
  },
};
</script>

<style lang="scss">
.dashboard-welcome-card {
  .card-body p:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Welcome-Card.vue